import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { useLocalStorage } from '@/hooks/useLocalStorage';
import { SuperAdminMenu } from '@/components/SuperAdminMenu/SuperAdminMenu';
import { StyledBodyFill, StyledBodyWrapper } from './styles';
import { Footer } from '@/component/Footer';
import { useCurrentUser, useCurrentUserAccess } from '@/store/currentUser';
import { Navbar } from '@/components/Navbar';
import { useFooterVisibility } from '@/component/App/component/LayoutWrapper/useFooterVisibility';
import { useNavbarVisibility } from '@/component/App/component/LayoutWrapper/useNavbarVisibility';
import { SkipLink, MAIN_CONTENT_ID } from '@/component/App/component/LayoutWrapper/SkipLink';

export const LayoutWrapper = ({ children }: { children?: React.ReactNode }): JSX.Element => {
  const { user } = useCurrentUser();
  const { isSuperAdmin } = useCurrentUserAccess();
  const [showSuperAdminTools] = useLocalStorage<boolean>('showSuperAdminTools', false);
  const shouldHideFooter = useFooterVisibility();
  const shouldHideNavbar = useNavbarVisibility();

  return (
    <>
      {!shouldHideNavbar && <SkipLink />}
      <StyledBodyWrapper banner={!!user?.isDebugging} navbarHidden={shouldHideNavbar}>
        {!shouldHideNavbar && <Navbar />}
        <StyledBodyFill id={MAIN_CONTENT_ID} tabIndex={-1}>
          <Suspense fallback={<div className="pageloader" />}>{children || <Outlet />}</Suspense>
        </StyledBodyFill>
        {!shouldHideFooter && <Footer />}
      </StyledBodyWrapper>
      {isSuperAdmin && showSuperAdminTools && <SuperAdminMenu />}
    </>
  );
};
